var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgMaintenance = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User/Regular/Maintenacne"
  }, /*#__PURE__*/React.createElement("path", {
    id: "user-shield",
    d: "M10.759 10.5C8.428 10.5 6.509 8.581 6.509 6.25C6.509 3.919 8.428 2 10.759 2C13.09 2 15.009 3.919 15.009 6.25C15.006 8.58 13.089 10.497 10.759 10.5ZM10.759 3.5C9.25 3.5 8.009 4.741 8.009 6.25C8.009 7.759 9.25 9 10.759 9C12.268 9 13.509 7.759 13.509 6.25C13.508 4.742 12.267 3.501 10.759 3.5ZM13 21.5H6.75C4.332 21.5 3 20.175 3 17.77C3 15.108 4.506 12 8.75 12H14.019C14.394 11.996 14.768 12.023 15.138 12.08C15.512 12.126 15.796 12.448 15.796 12.824C15.796 13.236 15.458 13.574 15.046 13.574C14.997 13.574 14.948 13.57 14.9 13.56C14.609 13.517 14.314 13.497 14.019 13.5H8.75C8.649 13.492 8.547 13.488 8.446 13.488C6.274 13.488 4.487 15.275 4.487 17.447C4.487 17.555 4.491 17.663 4.5 17.77C4.5 19.333 5.173 20 6.75 20H13C13.411 20 13.75 20.339 13.75 20.75C13.75 21.161 13.411 21.5 13 21.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7499 14.0811L20.5999 15.7261V19.0161L17.7499 20.6621L14.8999 19.0161V15.7261L17.7499 14.0811Z",
    stroke: "#FEBA00",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#FFFFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.7499 18.121C18.1644 18.121 18.5004 17.785 18.5004 17.3705C18.5004 16.9561 18.1644 16.6201 17.7499 16.6201C17.3355 16.6201 16.9995 16.9561 16.9995 17.3705C16.9995 17.785 17.3355 18.121 17.7499 18.121Z",
    fill: "#FEBA00"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMaintenance, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/maintenance.56062bd2.svg";
export { ForwardRef as ReactComponent };